import axios from 'axios'

// Create axios instance with proper configuration
const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1/',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

instance.interceptors.request.use(
  (config) => {
    // let token = ''
    // if (token == '' || token == undefined) {
    //   token = localStorage.getItem('token')
    // }

    // if (token) {
    //   config.headers['Authorization'] = `Bearer ${token}`
    // } else {
    // // ***********************************************************
    // // Using localStorage is insecure methodm we will use HTTPOnly Cookie instead.
    // // The backend support request.headers['Authorization'] = `Bearer` for supporting none-browser app, e.g. mobile app
    // // The backend expect get 'Authorization' in header, even its value does not have token
    config.headers['Authorization'] = `Bearer`
    // // ***********************************************************
    // }
    return config
  },
  (error) => {
    console.error('Request Interceptor Error:', error)
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    // logCookies()
    return response
  },
  (error) => {
    console.error('Response Interceptor Error:', error)
    if (error.response?.data) {
      return Promise.reject(error.response.data)
    }
    return Promise.reject(error)
  }
)

// instance.interceptors.response.use(
//   response => response,
//   async error => {
//     const originalRequest = error.config;
//     // Prevent infinite loop: do not retry for /auth/refresh itself
//     if (
//       error.response &&
//       error.response.status === 401 &&
//       !originalRequest._retry &&
//       !originalRequest.url.endsWith('/auth/refresh')
//     ) {
//       originalRequest._retry = true;
//       try {
//         await instance.post('/auth/refresh');
//         return instance(originalRequest);
//       } catch (refreshError) {
//         window.location.href = '/login';
//         return Promise.reject(refreshError);
//       }
//     }
//     return Promise.reject(error);
//   }
// ); 


// Ensure withCredentials is set
instance.defaults.withCredentials = true

export const Axios = instance
export default instance
